import path from 'path';
import {
  AddPanelSlider64Icon,
  ElementMaskIcon as MaskIcon,
  ElementSliderSlideIcon as SliderSlideIcon,
  ElementSliderDefaultIcon as SliderIcon,
} from '@packages/systems/spring';
import {wrapAddPanelIcon} from '@packages/systems/ui/shared-ui/wrapAddPanelIcon';
import SliderArrow from './SliderArrow';
import SliderMask from './SliderMask';
import SliderNav from './SliderNav';
import SliderSlide from './SliderSlide';
import SliderWrapper from './SliderWrapper';
import {Plugins, ElementPreset, Component} from '@packages/systems/wfdl';
import {qualify, iconName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  ENumber,
  EList,
  EEnum,
} from '@packages/systems/wfdl-ast';
import SliderWrapperType from './datatypes/SliderWrapperType';

const SliderAddPanelIcon = wrapAddPanelIcon(AddPanelSlider64Icon);

export const plugin = Plugins.PrivilegedPlugin({
  icons: {
    // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<Omit<any, "ref"> & RefAttributes<any>>' is not assignable to type 'ComponentType<IconProps>'.
    AddPanelSlider: SliderAddPanelIcon,
    Mask: MaskIcon,
    Slider: SliderIcon,
    SliderSlide: SliderSlideIcon,
  },
  dataTypes: {
    SliderWrapper: SliderWrapperType,
  },
  atoms: {
    SliderArrow,
    SliderMask,
    SliderNav,
    SliderSlide,
    SliderWrapper,
  },
  elementPresets: {
    SliderWrapper: ElementPreset.create({
      factory: EElement({
        id: 'Slider Wrapper',
        type: qualify(Plugins.name('Slider'), Component.name('SliderWrapper')),
        data: ERecord({
          slider: ERecord({
            navSpacing: ENumber(3),
            autoplay: EBoolean(false),
            delay: ENumber(4000),
            iconArrows: EBoolean(true),
            animation: EEnum('slide'),
            easing: EEnum('ease'),
            navNumbers: EBoolean(true),
            navShadow: EBoolean(false),
            navInvert: EBoolean(false),
            navRound: EBoolean(true),
            disableSwipe: EBoolean(false),
            duration: ENumber(500),
            infinite: EBoolean(true),
            hideArrows: EBoolean(false),
            autoMax: ENumber(0),
            type: EText('wrapper'),
          }),
          children: EList([
            EElement({
              id: 'Slider Mask',
              type: qualify(
                Plugins.name('Slider'),
                Component.name('SliderMask')
              ),
              data: ERecord({
                slider: ERecord({
                  type: EText('slides'),
                }),
                children: EList([
                  EElement({
                    id: 'Slider Slide',
                    type: qualify(
                      Plugins.name('Slider'),
                      Component.name('SliderSlide')
                    ),
                    data: ERecord({
                      tag: EEnum('div'),
                      slider: ERecord({
                        type: EText('slide'),
                      }),
                      children: EList([]),
                    }),
                  }),
                  EElement({
                    id: 'Slider Slide 2',
                    type: qualify(
                      Plugins.name('Slider'),
                      Component.name('SliderSlide')
                    ),
                    data: ERecord({
                      tag: EEnum('div'),
                      slider: ERecord({
                        type: EText('slide'),
                      }),
                      children: EList([]),
                    }),
                  }),
                ]),
              }),
            }),
            EElement({
              id: 'Slider Arrow',
              type: qualify(
                Plugins.name('Slider'),
                Component.name('SliderArrow')
              ),
              data: ERecord({
                slider: ERecord({
                  dir: EText('left'),
                }),
                children: EList([
                  EElement({
                    id: 'Icon',
                    type: qualify(Plugins.name('Icon'), Component.name('Icon')),
                    data: ERecord({
                      widget: ERecord({
                        type: EText('icon'),
                        icon: EText('slider-left'),
                      }),
                      children: EList([]),
                    }),
                  }),
                ]),
              }),
            }),
            EElement({
              id: 'Slider Arrow 2',
              type: qualify(
                Plugins.name('Slider'),
                Component.name('SliderArrow')
              ),
              data: ERecord({
                slider: ERecord({
                  dir: EText('right'),
                }),
                children: EList([
                  EElement({
                    id: 'Icon 2',
                    type: qualify(Plugins.name('Icon'), Component.name('Icon')),
                    data: ERecord({
                      widget: ERecord({
                        type: EText('icon'),
                        icon: EText('slider-right'),
                      }),
                      children: EList([]),
                    }),
                  }),
                ]),
              }),
            }),
            EElement({
              id: 'Slider Nav',
              type: qualify(
                Plugins.name('Slider'),
                Component.name('SliderNav')
              ),
              data: ERecord({
                slider: ERecord({
                  type: EText('nav'),
                }),
                children: EList([]),
              }),
            }),
          ]),
        }),
      }),
      icon: {
        small: qualify(Plugins.name('Slider'), iconName('Slider')),
        medium: qualify(Plugins.name('Slider'), iconName('AddPanelSlider')),
      },
      label: 'Slider',
      helpData: {
        description: [
          'Add dynamic components to your site, like image galleries and slideshows, rotating content, and more.',
          'You can add as many slides as you want, customize transitions, and control how they behave on different device types.',
        ],
        videoSrc:
          'https://d3e54v103j8qbb.cloudfront.net/videos/tooltips/slider.62e0a59c3a.mp4',
      },
      category: 'Other',
      addTabIndex: 7,
    }),
  },

  siteModules: [
    {
      filePaths: [path.resolve(__dirname, 'webflow-slider.js')],
      bundleIf: {
        type: 'node',
        test: ({data = {}}) =>
          data.slider != null &&
          typeof data.slider === 'object' &&
          data.slider.type === 'wrapper',
      },
    },
  ],
});
